import React from 'react'
import nav_gp from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/nav_gp.svg'
import magento from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/magento.svg'
import bc from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/bcnew.png'
import EGE from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/EGE.svg'
import bigcommerce from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/bigcommerce.png'
import qb from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/qb_thumb.png'
import shopify from '../../Pages/Dashboard/ConnectorPanel/Connectors/ConnectorListing/SubComponents/images/shopify.svg'

const ICONS_BY_SHORT_NAME = {
    EGE,
    Magento: magento,
    Nav: nav_gp,
    GP: nav_gp,
    AX: nav_gp,
    BC: bc,
    'Business Central': bc,
    BigCommerce: bigcommerce,
    QuickBooks: qb,
    Shopify: shopify,
}

/** Renders the connector's system logo for a given shortName, falling back to the name as text. */
const ConnectorIcon = ({ shortName, className }) => {
    const src = ICONS_BY_SHORT_NAME[shortName]
    if (!src) {
        return <span className={className}>{shortName}</span>
    }
    return <img src={src} alt={shortName} className={className} />
}

export default ConnectorIcon
